<div id="nav-overlay">
  <div class="spinner">
    <prime-loading-spinner></prime-loading-spinner>
  </div>
</div>
